"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IFloodgateStorageProvider = require("../Api/IFloodgateStorageProvider");
var Utils = require("../Utils");
var CampaignState = /** @class */ (function () {
    function CampaignState(campaignId, lastNominationTime, lastNominationBuildNumber, deleteAfterSecondsWhenStale, forceCandidacy, isCandidate, didCandidateTriggerSurvey, lastSurveyActivatedTime, lastSurveyId, lastSurveyStartTime, lastSurveyExpirationTime) {
        this.CampaignId = campaignId;
        this.LastNominationTimeUtc = lastNominationTime;
        this.LastNominationBuildNumber = lastNominationBuildNumber;
        this.DeleteAfterSecondsWhenStale = deleteAfterSecondsWhenStale;
        this.forceCandidacy = forceCandidacy;
        this.IsCandidate = isCandidate;
        this.DidCandidateTriggerSurvey = didCandidateTriggerSurvey;
        this.LastSurveyActivatedTimeUtc = lastSurveyActivatedTime;
        this.LastSurveyId = lastSurveyId;
        this.LastSurveyStartTimeUtc = lastSurveyStartTime;
        this.LastSurveyExpirationTimeUtc = lastSurveyExpirationTime;
        if (!this.validate()) {
            throw new Error("Constructor arguments are not valid");
        }
    }
    /**
     * Method to deserialize a JSON object to class object
     * @param input: JSON object
     * Returns class object
     */
    CampaignState.deserialize = function (input) {
        var result;
        if (!input) {
            return null;
        }
        try {
            result = new CampaignState(input.CampaignId, input.LastNominationTimeUtc, input.LastNominationBuildNumber, input.DeleteAfterSecondsWhenStale, false, // forceCandidacy
            input.IsCandidate, input.DidCandidateTriggerSurvey, input.LastSurveyActivatedTimeUtc, input.LastSurveyId, input.LastSurveyStartTimeUtc, input.LastSurveyExpirationTimeUtc);
        }
        catch (e) {
            // TODO(gachoi) Log parsing failed
            return null;
        }
        return result;
    };
    CampaignState.prototype.validate = function () {
        if (!this.CampaignId || !Utils.isString(this.CampaignId)) {
            return false;
        }
        if (Utils.isNullOrUndefined(this.LastNominationBuildNumber)
            || !Utils.isString(this.LastNominationBuildNumber)) {
            return false;
        }
        if (!Utils.isNumber(this.DeleteAfterSecondsWhenStale) || this.DeleteAfterSecondsWhenStale < 0) {
            return false;
        }
        if (!Utils.isBoolean(this.IsCandidate) || !Utils.isBoolean(this.DidCandidateTriggerSurvey)) {
            return false;
        }
        if (this.IsCandidate) {
            // Disallow the following null's if isCandidate == true
            if (Utils.isNullOrUndefined(this.LastSurveyStartTimeUtc) || Utils.isNullOrUndefined(this.LastSurveyExpirationTimeUtc)) {
                return false;
            }
            // LastSurveyId could be ""
            if (!Utils.isString(this.LastSurveyId)) {
                return false;
            }
        }
        if (this.DidCandidateTriggerSurvey) {
            // Disallow the following null's if didCandidateTriggerSurvey == true
            if (Utils.isNullOrUndefined(this.LastSurveyActivatedTimeUtc)) {
                return false;
            }
        }
        if (Utils.isNullOrUndefined(this.LastSurveyId)) {
            this.LastSurveyId = "";
        }
        else if (!Utils.isString(this.LastSurveyId)) {
            return false;
        }
        // LastNominationTime does not allow null
        if (Utils.isUtcDatetimeString(this.LastNominationTimeUtc)) {
            this.LastNominationTimeUtc = Utils.stringToDate(this.LastNominationTimeUtc);
            // invalidate if it's not a Date object
        }
        else if (!Utils.isDate(this.LastNominationTimeUtc)) {
            return false;
        }
        // Set value to distance past if value not provided
        if (Utils.isNullOrUndefined(this.LastSurveyActivatedTimeUtc)) {
            this.LastSurveyActivatedTimeUtc = Utils.getDistantPast();
            // check if it's UTC date time string, possibly coming from deserialize method
        }
        else if (Utils.isUtcDatetimeString(this.LastSurveyActivatedTimeUtc)) {
            this.LastSurveyActivatedTimeUtc = Utils.stringToDate(this.LastSurveyActivatedTimeUtc);
            // invalidate if it's not a Date object
        }
        else if (!Utils.isDate(this.LastSurveyActivatedTimeUtc)) {
            return false;
        }
        // Set value to distance past if value not provided
        if (Utils.isNullOrUndefined(this.LastSurveyStartTimeUtc)) {
            this.LastSurveyStartTimeUtc = Utils.getDistantPast();
            // check if it's string, possibly coming from deserialize method
        }
        else if (Utils.isUtcDatetimeString(this.LastSurveyStartTimeUtc)) {
            this.LastSurveyStartTimeUtc = Utils.stringToDate(this.LastSurveyStartTimeUtc);
            // invalidate if it's not a Date object
        }
        else if (!Utils.isDate(this.LastSurveyStartTimeUtc)) {
            return false;
        }
        // Set value to distance past if value not provided
        if (Utils.isNullOrUndefined(this.LastSurveyExpirationTimeUtc)) {
            this.LastSurveyExpirationTimeUtc = Utils.getDistantPast();
            // check if it's string, possibly coming from deserialize method
        }
        else if (Utils.isUtcDatetimeString(this.LastSurveyExpirationTimeUtc)) {
            this.LastSurveyExpirationTimeUtc = Utils.stringToDate(this.LastSurveyExpirationTimeUtc);
        }
        else if (!Utils.isDate(this.LastSurveyExpirationTimeUtc)) {
            return false;
        }
        return true;
    };
    /**
     * Record that the current survey was taken on this date
     *
     * @param date date
     */
    CampaignState.prototype.markCurrentSurveyTakenOnDate = function (date) {
        this.DidCandidateTriggerSurvey = true;
        this.LastSurveyActivatedTimeUtc = date != null ? date : new Date();
    };
    CampaignState.prototype.getCooldownStartDate = function () {
        if (!this.IsCandidate) {
            return this.LastNominationTimeUtc;
        }
        if (this.DidCandidateTriggerSurvey) {
            return this.LastSurveyActivatedTimeUtc;
        }
        // In practice this wil be equal to lastNominationTime, but
        // distribution models like a ramp effectively cause us to
        // shift our "effective nomination date" forward with the survey start date
        return this.LastSurveyStartTimeUtc;
    };
    return CampaignState;
}());
exports.CampaignState = CampaignState;
/**
 * Class representing what is stored in the file.
 */
var FileData = /** @class */ (function () {
    function FileData() {
    }
    return FileData;
}());
var FileBasedCampaignStateProvider = /** @class */ (function () {
    function FileBasedCampaignStateProvider(storage) {
        if (!storage) {
            throw new Error("storage must not be null");
        }
        this.storage = storage;
    }
    // @Override
    FileBasedCampaignStateProvider.prototype.load = function () {
        var readString = this.storage.read(IFloodgateStorageProvider.FileType.CampaignStates);
        if (!readString) {
            return [];
        }
        var fileData;
        try {
            fileData = JSON.parse(readString);
        }
        catch (e) {
            // TODO(gachoi) Log parsing failed
            return [];
        }
        var result = [];
        if (fileData && fileData.CampaignStates) {
            fileData.CampaignStates.forEach(function (state) {
                var newState = CampaignState.deserialize(state);
                if (newState) {
                    result.push(newState);
                }
            });
        }
        return result;
    };
    // @Override
    FileBasedCampaignStateProvider.prototype.save = function (campaignStates) {
        if (!campaignStates) {
            return;
        }
        var fileData = new FileData();
        fileData.CampaignStates = campaignStates;
        var writeString = JSON.stringify(fileData);
        this.storage.write(IFloodgateStorageProvider.FileType.CampaignStates, writeString);
    };
    return FileBasedCampaignStateProvider;
}());
exports.FileBasedCampaignStateProvider = FileBasedCampaignStateProvider;
